// extracted by mini-css-extract-plugin
module.exports = {"btn-color":"BizCompanyDataViewHeaderInteraction_btn-color__3WSFH"};